import React from 'react';
import Icon from '../../../components/AppIcon';

const PropertyInfo = ({ listing }) => {
  const property = listing?.properties;

  return (
    <div className="bg-card rounded-xl border border-border p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-foreground mb-2">
          {property?.address}
        </h1>
        <p className="text-lg text-muted-foreground">
          {property?.suburb}, {property?.state} {property?.postcode}
        </p>
      </div>

      <div className="flex flex-wrap gap-6 mb-6 pb-6 border-b border-border">
        {property?.beds && (
          <div className="flex items-center gap-2">
            <Icon name="Bed" size={20} color="var(--color-primary)" />
            <div>
              <p className="text-sm text-muted-foreground">Bedrooms</p>
              <p className="font-semibold text-foreground">{property?.beds}</p>
            </div>
          </div>
        )}
        {property?.baths && (
          <div className="flex items-center gap-2">
            <Icon name="Bath" size={20} color="var(--color-primary)" />
            <div>
              <p className="text-sm text-muted-foreground">Bathrooms</p>
              <p className="font-semibold text-foreground">{property?.baths}</p>
            </div>
          </div>
        )}
        {property?.parking && (
          <div className="flex items-center gap-2">
            <Icon name="Car" size={20} color="var(--color-primary)" />
            <div>
              <p className="text-sm text-muted-foreground">Parking</p>
              <p className="font-semibold text-foreground">{property?.parking}</p>
            </div>
          </div>
        )}
        <div className="flex items-center gap-2">
          <Icon name="Home" size={20} color="var(--color-primary)" />
          <div>
            <p className="text-sm text-muted-foreground">Type</p>
            <p className="font-semibold text-foreground capitalize">{property?.type}</p>
          </div>
        </div>
      </div>

      <div>
        <h2 className="text-xl font-bold text-foreground mb-3">About this property</h2>
        {listing?.description_short && (
          <p className="text-lg text-foreground mb-4 font-medium">
            {listing?.description_short}
          </p>
        )}
        {listing?.description_long && (
          <p className="text-muted-foreground leading-relaxed whitespace-pre-line">
            {listing?.description_long}
          </p>
        )}
      </div>
    </div>
  );
};

export default PropertyInfo;